/// <reference types="vite/client" />

import packageJson from '../../package.json';

// Environment variables utility for Vite
// This helps maintain compatibility between webpack and Vite builds

// Environment configuration
export const env = {
  API: import.meta.env.VITE_API || import.meta.env.REACT_APP_API || '',
  CDN: import.meta.env.VITE_CDN || import.meta.env.REACT_APP_CDN || '',
  VERSION: packageJson.version,
  WS: import.meta.env.VITE_WS || import.meta.env.REACT_APP_WS || '',
  TESTING: import.meta.env.VITE_TESTING || import.meta.env.REACT_APP_TESTING || 'false',
  PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL || import.meta.env.REACT_APP_PUBLIC_URL || '/',
  SECRET: import.meta.env.VITE_SECRET || import.meta.env.REACT_APP_SECRET || '',
  GIPHY_KEY: import.meta.env.VITE_GIPHY_KEY || import.meta.env.REACT_APP_GIPHY_KEY || '',
  STRIPE_KEY: import.meta.env.VITE_STRIPE_KEY || import.meta.env.REACT_APP_STRIPE_KEY || '',
  EMAIL: import.meta.env.VITE_EMAIL || import.meta.env.REACT_APP_EMAIL || '',
  PASSWORD: import.meta.env.VITE_PASSWORD || import.meta.env.REACT_APP_PASSWORD || '',
  IMAGE_URL: import.meta.env.VITE_IMAGE_URL || import.meta.env.REACT_APP_IMAGE_URL || '',
  REMOTE: import.meta.env.VITE_REMOTE || import.meta.env.REACT_APP_REMOTE || 'false',
  NODE_ENV: import.meta.env.MODE || 'development',
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
};

// Legacy support - this can be gradually replaced
export const legacyProcessEnv = {
  REACT_APP_API: env.API,
  REACT_APP_CDN: env.CDN,
  REACT_APP_VERSION: env.VERSION,
  REACT_APP_WS: env.WS,
  REACT_APP_TESTING: env.TESTING,
  REACT_APP_PUBLIC_URL: env.PUBLIC_URL,
  REACT_APP_SECRET: env.SECRET,
  REACT_APP_GIPHY_KEY: env.GIPHY_KEY,
  REACT_APP_STRIPE_KEY: env.STRIPE_KEY,
  REACT_APP_EMAIL: env.EMAIL,
  REACT_APP_PASSWORD: env.PASSWORD,
  REACT_APP_IMAGE_URL: env.IMAGE_URL,
  REACT_APP_REMOTE: env.REMOTE,
  NODE_ENV: env.NODE_ENV,
};
